import React, { FC, ReactElement } from 'react';
import { MessageBox, Wrapper } from '@yandex-lego/components/MessageBox/desktop/bundle';
import { Textarea } from '@yandex-lego/components/Textarea/desktop/bundle';
import { RatingDynamic } from '@yandex-int/serp-components/RatingDynamic/desktop';

import { cnStreamScreen } from '../StreamScreen.cn';
import { i18nStreamScreen } from '../StreamScreen';
import { StreamScreenRateInformerProps } from './StreamScreen-RateInformer.interface';

import './StreamScreen-RateInformer.css';

export const RateInformer: FC<StreamScreenRateInformerProps> = (props): ReactElement => {
    const {
        rating,
        message,
        onRatingChange,
        onMessageChange,
        onClose,
        actionButtons,
        trailing,
        replacer,
    } = props;

    const isStreamRated = rating > 0;

    return (
        <MessageBox
            view="promo"
            size="l"
            layout="functional"
            className={cnStreamScreen('RateInformer')}
            actions={actionButtons}
            onClose={onClose}
        >
            <Wrapper trailing={trailing}>
                <div className={cnStreamScreen('RateInformerContent')}>
                    {
                        replacer || (
                            <>
                                <div className={cnStreamScreen('RateInformerTitle')}>
                                    {i18nStreamScreen('rate-informer-title')}
                                </div>
                                <div className={cnStreamScreen('RateInformerRating')}>
                                    <RatingDynamic
                                        size="m"
                                        value={rating}
                                        onChange={onRatingChange}
                                    />
                                </div>
                                {
                                    isStreamRated && (
                                        <Textarea
                                            value={message}
                                            onChange={onMessageChange}
                                            view="default"
                                            size="m"
                                            placeholder={i18nStreamScreen('rate-informer-textarea-placeholder')}
                                            className={cnStreamScreen('RateInformerMessage')}
                                        />
                                    )
                                }
                            </>
                        )
                    }
                </div>
            </Wrapper>
        </MessageBox>
    );
};
